export default __webpack_public_path__ + "static/media/tumorChannel1.170af33d.png";